module.exports = __webpack_public_path__ + "img/private_sector_team.adc8a6d7.jpg";